import axios from "../../utility/axiosInstance"

export async function getJob(id) {
    const response = await axios(`/jobs/${id}`)

    return response.data
}